import { InputProps, SelectInput } from "react-admin"
import { UnitChoices } from "resources/billing/billing_constants"

export const ProductUnitSelectInput: React.FC<InputProps> = (props) => (
  <SelectInput label="Unit" {...props} choices={UnitChoices} />
)
